import NotificationOutline from '@simplywallst/ui-core/icons/NotificationOutline';

export const EmptyState = () => {
  return (
    <div className="grid place-content-center">
      <span className="text-center">
        <NotificationOutline className="size-x3 fill-soft" />
      </span>
      <h3 className="mb-x1 mt-x1_5 text-center text-sm font-strong text-solid">
        No updates in this category... yet!
      </h3>
      <p className="text-center text-xs text-soft md:m-0">
        When your portfolio holdings has updates they&apos;ll appear here.
      </p>
    </div>
  );
};
